import template from './acris-faq-group-list.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('acris-faq-group-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
        Mixin.getByName('placeholder')
    ],

    data() {
        return {
            items: null,
            isLoading: false,
            showDeleteModal: false,
            repository: null,
            total: 0
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    computed: {
        entityRepository() {
            return this.repositoryFactory.create('acris_faq_group');
        },

        columns() {
            return this.getColumns();
        }
    },

    methods: {
        getList() {
            this.isLoading = true;
            const criteria = new Criteria(this.page, this.limit);
            criteria.addAssociation('productStreams');
            criteria.addAssociation('faqs');
            criteria.addSorting(Criteria.sort('priority', 'DESC'));
            criteria.addSorting(Criteria.sort('name', 'ASC'));
            criteria.setTerm(this.term);

            this.entityRepository.search(criteria, Shopware.Context.api).then((items) => {
                this.total = items.total;
                this.items = items;
                this.isLoading = false;

                return items;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onDelete(id) {
            this.showDeleteModal = id;
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
        },

        getColumns() {
            return [{
                property: 'name',
                inlineEdit: 'string',
                label: 'acris-faq-group.list.columnName',
                routerLink: 'acris.faq.group.detail',
                allowResize: true,
                primary: true
            }, {
                property: 'description',
                inlineEdit: 'string',
                label: 'acris-faq-group.list.columnDescription',
                routerLink: 'acris.faq.group.detail',
                allowResize: true
            }, {
                property: 'priority',
                inlineEdit: 'number',
                label: 'acris-faq-group.list.columnPriority',
                routerLink: 'acris.faq.group.detail',
                allowResize: true
            }, {
                property: 'active',
                label: 'acris-faq-group.list.columnActive',
                inlineEdit: 'boolean',
                allowResize: true
            }];
        }
    }
});

